/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type {
  ContentStackPdpSlot,
  FormattedContentStackDefaultPDP,
  FormattedContentStackPremiumPDP,
} from '@/features/contentstack/interface';

export function hasBVReviewsSection(
  contentItem:
    | NonNullable<FormattedContentStackPremiumPDP['pageBody']>[number]
    | NonNullable<FormattedContentStackDefaultPDP['pageBody']>[number]
    | NonNullable<ContentStackPdpSlot['pdp_slot_content']>[number],
): boolean {
  if ('bazaarvoice' in contentItem && contentItem.bazaarvoice?.enable) {
    return true;
  }
  return false;
}
